import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from '@mui/styles/makeStyles';
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";
import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';


const useStyles = makeStyles(sectionTextStyle);

export default function SectionText() {
  const classes = useStyles();
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  // Embed twitter
  React.useEffect(() => {
    const parentId = 'twitter-embed';
    const scriptId = 'twitter-script';

    if(!window) return;
    const parentNode = window.document.getElementById(parentId);
    if(parentNode) {
      const script = window.document.createElement('script');
      script.src = 'https://platform.twitter.com/widgets.js';
      script.async = true;
      script.charSet = 'utf-8';
      script.id = scriptId;
      parentNode.appendChild(script);
    }

    return(() => {
      if(!window) return;
      const parentNode = window.document.getElementById(parentId);
      if(parentNode) { 
        parentNode.removeChild(window.document.getElementById(scriptId));
      }
    })

  })

  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
 
        
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>Data Discrepancies between Google Analytics and Data Studio Extract - This is a problem!</h3>
          <p> <i>COMMENT: June 18 2020.
          The technical reason for the problems described in this blog can be explained by the following:
          <br /><br /> 
          The various Google stack connectors in Data Studio such as Google Analytics and Search Console act as interfaces to the said underlying system.
          Hence they can be expected to return the same figures as that system. Those systems perform their own agggregation, cleaning, grouping etc etc before returning results. 
          <br /><br />
          Using a data extract means you miss out on all of this "underlying system functionality". 
          <br /><br />
          Now - does this mean the Extract Data connector is broken? No. Its not. 
          <br /><br />
          Does this mean you can rebuild your very slow Google Analytics report in Data Studio using Extract Data? Unless your report has the simplest layout, ie one scorecard with one number in it eg "Users", which of course excludes every practical dashboard in reality - then no you cant. 😀🤨
          <br /><br />
          </i>
          </p>
 

              <blockquote className="twitter-tweet" data-theme="dark">
                <p lang="en" dir="ltr">
                  Just made a test with the <a href="https://twitter.com/hashtag/datastudio?src=hash&amp;ref_src=twsrc%5Etfw">#datastudio</a> data extractor: AMAZING. Super fast.
                  <br /><br />
                  If you have problems with slow datasources try this method from master mind <a href="https://twitter.com/Helpfullee?ref_src=twsrc%5Etfw">@Helpfullee</a> <a href="https://t.co/kKThQPsSLv">https://t.co/kKThQPsSLv</a>
                </p>
                &mdash; Ralph Spandl (@ralph_spandl) <a href="https://twitter.com/ralph_spandl/status/1272883567937368066?ref_src=twsrc%5Etfw">June 16, 2020</a>
              </blockquote>
              

          <p> 
          <br /><br />
          This tweet ended up in a bit of a firestorm. Scroll through it to see where I and others got involved. On the back of it I decided to really prove the data frustrations I was getting with Data Studio and "Data Extract".
          <br /><br />
          Ralph Spandl has designed some awesome custom add ons for data studio including "Data Studio Chart Library" just released (which is very good but pricey) (See <a href="https://store.r42.ca/" target="_blank">here</a> for more)
          </p>

          <h3 className={classes.title}>Data Studio - Data Extract - How its supposed to work (The Promise)</h3>
          <p>
          Anybody who has used Data Studio will have encountered its most crushing problem... SLLLOOOWWWNNNEEESSSS... 
          <br /><br />
          Its not a stretch to say that Data Studio's main purpose is to provide a convenient link to report on Google Ads and Analytics Data. Or anything in the Google Advertising stack (Youtube etc).
          <br /><br />
          The problem is every chart you link to these data sources (or any data source) is actually an API call to the said data source. Whats more - each and every chart/table makes its own API call... so if you have a dashboard with 5 scorecards, a sole table and a sole line graph - this is still 7 seperate calls to the data source. This very often leads to excrutiating wait times - esepcially if you have a big Google Analytics or Google Ads account.
          <br /><br />
          <strong>We are living in 2020!!!! People want to see stuff quickly. Latency is the biggest turn off going round. Especially if you are tying to prove a point to someone via a dashboard!</strong>

          </p>
          <div className="tenor-gif-embed" data-postid="7195670" data-share-method="host" data-width="100%" data-aspect-ratio="2.0">
            <a href="https://tenor.com/view/theoffice-stanley-blank-stare-waiting-gif-7195670">Theoffice Stanley GIF</a> from <a href="https://tenor.com/search/theoffice-gifs">Theoffice GIFs</a>
          </div>
          <div id='twitter-embed' />

          <p>
          <br /><br />
          Enter <strong>Data Extract</strong> to the rescue!!! 😃🚑🚨 
          </p>
          </GridItem>
          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-06-17-DataStudioExtractsProblems/ed.webp"
                      alt="..."
                      className={imgClasses}
                    />
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p>
          This Data Studio connector allows you to connect to any data source and choose a subset of it to be "stored" and refreshed on a daily basis &lt;- allowing you to pull super quick data to your reports.
          <br /><br />
          Wow. amazing. All my problems are solved! Instead of connecting to the APIs above, Ill create a Data Extract for my reports and use that..
          </p>


          </GridItem>

          <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Data Studio - Data Extract - How its really working (Reality)</h3>
          <p>
          Help documentation is scant on the ground for this. There is no real explanation on how Data Extract actually works. What we do know is that extracts must be under 100MB in size... ok then.
          <br /><br />
          The huge, massive, GINOMORMOUS problem with Data Extract - is that it DOESNT WORK PROPERLY. Or maybe thats harsh - it doesnt work as it SHOULD. The exact same extract of data will be completely different to the underlying data source in some cases.
          <br /><br />
          Not great eh.
          <br /><br />
          This means the nifty new report you just built with extracts... yeah well thats just completely wrong and garbage and you may as well throw in the bin.
          <br /><br />
          Check out the Data Studio dashboard we created that highlights the problems here. For a fairly small and reasonablish/common extract of data we got horrific diffferences between GA and the extract. 
          <br /><br />
          MAKE SURE YOU OPEN THE REPORT IN DATA STUDIO ITS REALLY GOOD :-)))
          </p>
          </GridItem>

          <GridItem xs={12} sm={8} md={8}>
          <Card className="scott">
            <CardActionArea>
              <CardMedia
                className="scott2"
                style={{height: 0, paddingTop: '56.25%'}}
                iframe="https://datastudio.google.com/embed/reporting/2dcce794-2ac2-4610-a87d-31b7f20d6d82/page/g5dUB"
                image="/img/posts/2020-06-17-DataStudioExtractsProblems/ed.jpg"
                title="Contemplative Reptile"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Lizard
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging
                  across all continents except Antarctica
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button size="small" color="primary">
                Share
              </Button>
              <Button size="small" color="primary">
                Learn More
              </Button>
            </CardActions>
          </Card>
          
          </GridItem>

          <GridItem xs={12} sm={8} md={8}>
            <p>

          <br /><br />
          See below for our methodology:
          <br /><br />
          1) We made an extract from GA for the Demo account. It is fixed length: Mar 1, 2020 - Jun 15, 2020. (Note: the final day is in the past - ie not "today" to avoid issues where the extract is out of date)
          <br /><br />
          2) Our testing is for May 20 - Jun15, but any dates up to Jun 15 will highlight the same problem.
          <br /><br />
          3) The data extract is: 
          <br />Dimensions - Default Channel Grouping, Device Category, Country, Page, Gender, City 
          <br />Metrics - Pageviews, Sessions, Users, Avg. Session Duration, Bounce Rate, New Users
          <br /><br />
          4) Things that make no difference
          <br />- Making the extract smaller  &lt;- we tried everything all the way back to a 1 day extract. All yielded broken results. So its not extract size (unless this one day subsample of the demo store is &gt; 100MB???)
          <br />- We tried to change the extract in increments Problems occur when only using Default Channel Grouping, Device Category, Country and the same metrics - see bottom extra table
          <br /><br />
          Conclusion - Data Extract for GA is Broken. Badly. And only useable (maybe) if you use very small extracts with small number of dimensions and metrics. UNFORTUNATELY for any big report, this would mean tonnes and tonnes of extracts making it unusable practically...

          </p>

        </GridItem>

        


      </GridContainer>
    </div>

  );
}
